"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StandardButtonWithIcon = exports.PrimaryButtonWithIcon = exports.NeutralButtonWithIcon = exports.NeutralBorderlesButtonWithIcon = exports.DestructiveButtonWithIcon = exports.ButtonWithIcon = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"));
var _react = _interopRequireDefault(require("react"));
var _buttonWithIconModule = _interopRequireDefault(require("./button-with-icon.module.scss"));
var _Button = require("../../../elements/button/Button");
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["prefixIcon", "suffixIcon", "children", "className"],
  _excluded2 = ["children"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"];
var ButtonWithIcon = function ButtonWithIcon(_ref) {
  var prefixIcon = _ref.prefixIcon,
    suffixIcon = _ref.suffixIcon,
    children = _ref.children,
    className = _ref.className,
    buttonProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_Button.Button, Object.assign({}, buttonProps, {
    className: (0, _classnames.default)(_buttonWithIconModule.default['button-with-icon'], className)
  }), prefixIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: _buttonWithIconModule.default['button-with-icon__prefix-icon']
  }, prefixIcon), children, suffixIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: _buttonWithIconModule.default['button-with-icon__suffix-icon']
  }, suffixIcon));
};
exports.ButtonWithIcon = ButtonWithIcon;
var PrimaryButtonWithIcon = function PrimaryButtonWithIcon(_ref2) {
  var children = _ref2.children,
    rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return /*#__PURE__*/_react.default.createElement(ButtonWithIcon, Object.assign({
    level: "primary"
  }, rest), children);
};
exports.PrimaryButtonWithIcon = PrimaryButtonWithIcon;
var StandardButtonWithIcon = function StandardButtonWithIcon(_ref3) {
  var children = _ref3.children,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return /*#__PURE__*/_react.default.createElement(ButtonWithIcon, Object.assign({
    level: "standard"
  }, rest), children);
};
exports.StandardButtonWithIcon = StandardButtonWithIcon;
var NeutralButtonWithIcon = function NeutralButtonWithIcon(_ref4) {
  var children = _ref4.children,
    rest = (0, _objectWithoutProperties2.default)(_ref4, _excluded4);
  return /*#__PURE__*/_react.default.createElement(ButtonWithIcon, Object.assign({
    level: "neutral"
  }, rest), children);
};
exports.NeutralButtonWithIcon = NeutralButtonWithIcon;
var NeutralBorderlesButtonWithIcon = function NeutralBorderlesButtonWithIcon(_ref5) {
  var children = _ref5.children,
    rest = (0, _objectWithoutProperties2.default)(_ref5, _excluded5);
  return /*#__PURE__*/_react.default.createElement(ButtonWithIcon, Object.assign({
    level: "neutral-borderless"
  }, rest), children);
};
exports.NeutralBorderlesButtonWithIcon = NeutralBorderlesButtonWithIcon;
var DestructiveButtonWithIcon = function DestructiveButtonWithIcon(_ref6) {
  var children = _ref6.children,
    rest = (0, _objectWithoutProperties2.default)(_ref6, _excluded6);
  return /*#__PURE__*/_react.default.createElement(ButtonWithIcon, Object.assign({
    level: "destructive"
  }, rest), children);
};
exports.DestructiveButtonWithIcon = DestructiveButtonWithIcon;